export default {
    header: {
      switch: {
        '/zh-CN': '切换主题色',
        '/en-US': 'Change Theme Color'
      },
      download: {
        '/zh-CN': '下载主题',
        '/en-US': 'Download Theme'
      },
      help: {
        '/zh-CN': '帮助',
        '/en-US': 'Help'
      }
    },
    menu: {
      pageOne: {
        '/zh-CN': '页面1',
        '/en-US': 'Page One'
      },
      pageTwo: {
        '/zh-CN': '页面2',
        '/en-US': 'Page Two'
      },
      pageThree: {
        '/zh-CN': '页面3',
        '/en-US': 'Page Three'
      }
    },
    form: {
      theme: {
        '/zh-CN': '主题色',
        '/en-US': 'Theme color'
      },
      switch: {
        '/zh-CN': '切换',
        '/en-US': 'Change'
      },
      reset: {
        '/zh-CN': '重置',
        '/en-US': 'Reset'
      }
    },
    validate: {
      required: {
        '/zh-CN': '主题色不能为空',
        '/en-US': 'Theme color is required'
      },
      format: {
        '/zh-CN': '请输入 hex 格式的主题色',
        '/en-US': 'Theme color should be in hex format'
      }
    },
    breadcrumb: {
      main: {
        '/zh-CN': '首页',
        '/en-US': 'Main'
      },
      project: {
        '/zh-CN': '项目',
        '/en-US': 'Project'
      },
      page: {
        '/zh-CN': '页面一',
        '/en-US': 'Page One'
      }
    },
    query: {
      name: {
        '/zh-CN': '姓名',
        '/en-US': 'Name'
      },
      date: {
        '/zh-CN': '日期',
        '/en-US': 'Date'
      },
      search: {
        '/zh-CN': '搜索',
        '/en-US': 'Search'
      },
      nameHolder: {
        '/zh-CN': '请输入姓名',
        '/en-US': 'Please input name'
      },
      dateHolder: {
        '/zh-CN': '请选择日期',
        '/en-US': 'Please select date'
      }
    },
    table: {
      name: {
        '/zh-CN': '姓名',
        '/en-US': 'Name'
      },
      date: {
        '/zh-CN': '日期',
        '/en-US': 'Date'
      },
      address: {
        '/zh-CN': '地址',
        '/en-US': 'Address'
      },
      zip: {
        '/zh-CN': '邮编',
        '/en-US': 'Zip Code'
      },
      operations: {
        '/zh-CN': '操作',
        '/en-US': 'Operations'
      },
      edit: {
        '/zh-CN': '编辑',
        '/en-US': 'Edit'
      },
      delete: {
        '/zh-CN': '删除',
        '/en-US': 'Delete'
      }
    },
    help: {
      title: {
        '/zh-CN': '帮助',
        '/en-US': 'Help'
      },
      content: {
        '/zh-CN': `
          <p>1、点击顶部栏中的「切换主题色」，在弹出的对话框中选择主题色，并点击「切换」按钮；</p>
          <p>2、此时本页面会按照你选定的主题色重新生成样式，你可以预览应用了新主题色的 Element；</p>
          <p>3、点击顶部栏中的「下载主题」，会自动下载应用了新主题色的样式文件；</p>
          <p>4、关于如何在项目中引入新的样式文件，请参考官方文档中<a href="http://element.eleme.io/#/zh-CN/component/custom-theme#yin-ru-zi-ding-yi-zhu-ti" target="_blank">自定义主题</a>的相关内容；</p>
          <p>5、如果需要除主题色之外更深层次的样式定制，请使用 <a href="https://github.com/ElementUI/element-theme" target="_blank">element-theme</a>。</p>
          <p>注意：本页面仅用来预览主题，页面上的元素不含交互逻辑。</p>
        `,
        '/en-US': `
          <p>1. Click the 'Change Theme Color' button on the header menu, choose a theme color in the popped dialog, and click 'Change';</p>
          <p>2. Now this page will apply a new style generated with your newly appointed theme color, so you can preview what Element looks like once this color is applied;</p>
          <p>3. Click the 'Download Theme' button on the header menu, and you can download the style files with the new theme color;</p>
          <p>4、To import new style files in your project, please refer to the <a href="http://element.eleme.io/#/en-US/component/custom-theme#import-custom-theme" target="_blank">custom theme</a> section in our official documentation;</p>
          <p>5. If you need more customization than just changing the theme color, please use <a href="https://github.com/ElementUI/element-theme" target="_blank">element-theme</a>.</p>
          <p>Note that this page is only for previewing themes, so the components on this page are not interactive.</p>
        `
      },
      ok: {
        '/zh-CN': '确定',
        '/en-US': 'OK'
      }
    }
  }
  